import lottie from 'lottie-web';

export default function initLottie() {
    const images = document.querySelectorAll('#lottie');

    function lottieAnimate(element) {
        const imgPath = element.getAttribute('data-lottie');

        lottie.loadAnimation({
            container: element,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: imgPath,
        });
        element.classList.add('lottie-activated');
    }

    function lottieActivate() {
        let i = 0;
        while (i < images.length) {
            const image = images[i];
            lottieAnimate(image);
            i++;
        }
    }
    setTimeout(() => {
        lottieActivate();
    }, 1000);
}
